import React, { useState, useEffect } from "react";
import LoadingComponent from "commons/loading/Loading.component";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const GrowthPortfolio = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [portfolioData, setPortfolioData] = useState<any>(null);
    const [selectedCategory, setSelectedCategory] = useState('all');

    // 더미 데이터
    const dummyPortfolioData = {
        categories: [
            { id: 'all', name: '전체', count: 12 },
            { id: 'vocal', name: '보컬', count: 5 },
            { id: 'dance', name: '댄스', count: 4 },
            { id: 'acting', name: '연기', count: 3 }
        ],
        items: [
            {
                id: 1,
                title: "보컬 - 'Into the Unknown' 커버",
                category: "vocal",
                type: "video",
                thumbnail: "/imgs/dummy/girls/girl-1/pexels-chuotanhls-15575178.jpg",
                description: "겨울왕국 2 OST를 한국어로 커버했습니다. 고음 부분에서 특히 신경 썼어요.",
                date: "2024-03-15",
                duration: "3:45",
                views: 1250,
                likes: 89,
                tags: ["보컬", "커버", "겨울왕국", "고음"],
                url: "https://youtube.com/watch?v=example1"
            },
            {
                id: 2,
                title: "댄스 - 힙합 기본 동작 연습",
                category: "dance",
                type: "video",
                thumbnail: "/imgs/dummy/girls/girl-2/pexels-chuotanhls-15575179.jpg",
                description: "힙합의 기본 동작들을 연습한 영상입니다. 팝핀과 락킹 동작을 포함했습니다.",
                date: "2024-03-14",
                duration: "2:30",
                views: 890,
                likes: 67,
                tags: ["댄스", "힙합", "팝핀", "락킹"],
                url: "https://youtube.com/watch?v=example2"
            },
            {
                id: 3,
                title: "연기 - 감정 표현 연습",
                category: "acting",
                type: "video",
                thumbnail: "/imgs/dummy/boys/boy-1/pexels-chuotanhls-15575170.jpg",
                description: "기쁨, 슬픔, 분노 등 다양한 감정을 표현하는 연기 연습입니다.",
                date: "2024-03-13",
                duration: "4:15",
                views: 650,
                likes: 45,
                tags: ["연기", "감정표현", "기본기"],
                url: "https://youtube.com/watch?v=example3"
            },
            {
                id: 4,
                title: "보컬 - 'All of Me' 커버",
                category: "vocal",
                type: "video",
                thumbnail: "/imgs/dummy/girls/girl-3/pexels-chuotanhls-15575173.jpg",
                description: "John Legend의 'All of Me'를 한국어로 커버했습니다. 감정 표현에 집중했습니다.",
                date: "2024-03-12",
                duration: "4:20",
                views: 1100,
                likes: 78,
                tags: ["보컬", "커버", "All of Me", "감정"],
                url: "https://youtube.com/watch?v=example4"
            },
            {
                id: 5,
                title: "댄스 - K-pop 댄스 커버",
                category: "dance",
                type: "video",
                thumbnail: "/imgs/dummy/girls/girl-4/pexels-chuotanhls-15575170.jpg",
                description: "인기 K-pop 곡의 댄스를 커버했습니다. 정확한 동작과 리듬감을 연습했습니다.",
                date: "2024-03-11",
                duration: "3:30",
                views: 1450,
                likes: 95,
                tags: ["댄스", "K-pop", "커버", "리듬"],
                url: "https://youtube.com/watch?v=example5"
            },
            {
                id: 6,
                title: "연기 - 모노로그 연습",
                category: "acting",
                type: "video",
                thumbnail: "/imgs/dummy/boys/boy-2/pexels-chuotanhls-15575179.jpg",
                description: "영화 '기생충'의 모노로그를 연습했습니다. 캐릭터의 내면을 표현하는데 집중했습니다.",
                date: "2024-03-10",
                duration: "2:45",
                views: 720,
                likes: 52,
                tags: ["연기", "모노로그", "기생충", "캐릭터"],
                url: "https://youtube.com/watch?v=example6"
            }
        ],
        stats: {
            totalVideos: 12,
            totalViews: 15600,
            totalLikes: 890,
            averageDuration: "3:25"
        }
    };

    useEffect(() => {
        // 더미 데이터 로딩 시뮬레이션
        setIsLoading(true);
        setTimeout(() => {
            setPortfolioData(dummyPortfolioData);
            setIsLoading(false);
        }, 1000);
    }, []);

    const filteredItems = selectedCategory === 'all' 
        ? portfolioData?.items 
        : portfolioData?.items?.filter((item: any) => item.category === selectedCategory);

    const formatDuration = (duration: string) => {
        return duration;
    };

    const formatViews = (views: number | undefined | null) => {
        if (views === undefined || views === null) {
            return '0';
        }
        if (views >= 1000000) {
            return (views / 1000000).toFixed(1) + 'M';
        } else if (views >= 1000) {
            return (views / 1000).toFixed(1) + 'K';
        }
        return views.toString();
    };

    if (isLoading || !portfolioData) {
        return <LoadingComponent />;
    }

    return (
        <main className="bg-gray-50 min-h-screen">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {/* 헤더 */}
                <div className="mb-8">
                    <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
                        {getLanguageValue(PAGE_TYPE.STUDENT, "growthPortfolio.txtTitle")}
                    </h1>
                    <p className="text-gray-600 text-sm sm:text-base">
                        {getLanguageValue(PAGE_TYPE.STUDENT, "growthPortfolio.txtDesc")}
                    </p>
                </div>

                {/* 통계 카드 */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 mb-8">
                    <div className="bg-gray-50 p-4 sm:p-6 rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                        <div className="text-center">
                            <h3 className="text-sm sm:text-base font-medium mb-2 text-gray-500">
                                {getLanguageValue(PAGE_TYPE.STUDENT, "growthPortfolio.txtTotalVideos")}
                            </h3>
                            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#CF3688]">
                                {portfolioData?.stats?.totalVideos}
                            </p>
                        </div>
                    </div>
                    <div className="bg-gray-50 p-4 sm:p-6 rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                        <div className="text-center">
                            <h3 className="text-sm sm:text-base font-medium mb-2 text-gray-500">
                                {getLanguageValue(PAGE_TYPE.STUDENT, "growthPortfolio.txtTotalViews")}
                            </h3>
                            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#CF3688]">
                                {formatViews(portfolioData?.stats?.totalVideos)}
                            </p>
                        </div>
                    </div>
                    <div className="bg-gray-50 p-4 sm:p-6 rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                        <div className="text-center">
                            <h3 className="text-sm sm:text-base font-medium mb-2 text-gray-500">
                                {getLanguageValue(PAGE_TYPE.STUDENT, "growthPortfolio.txtTotalLikes")}
                            </h3>
                            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#CF3688]">
                                {formatViews(portfolioData?.stats?.totalLikes)}
                            </p>
                        </div>
                    </div>
                    <div className="bg-gray-50 p-4 sm:p-6 rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                        <div className="text-center">
                            <h3 className="text-sm sm:text-base font-medium mb-2 text-gray-500">
                                {getLanguageValue(PAGE_TYPE.STUDENT, "growthPortfolio.txtAverageDuration")}
                            </h3>
                            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#CF3688]">
                                {portfolioData?.stats?.averageDuration}
                            </p>
                        </div>
                    </div>
                </div>

                {/* 카테고리 필터 */}
                <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6 mb-8">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
                        {getLanguageValue(PAGE_TYPE.STUDENT, "growthPortfolio.txtCategories")}
                    </h2>
                    <div className="flex flex-wrap gap-3 sm:gap-4">
                        {portfolioData?.categories?.map((category: any) => (
                            <button
                                key={category.id}
                                onClick={() => setSelectedCategory(category.id)}
                                className={`px-4 py-2 sm:px-6 sm:py-3 rounded-xl font-medium transition-all duration-200 ${
                                    selectedCategory === category.id
                                        ? 'bg-purple-500 text-white shadow-lg'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                {category.name} ({category.count})
                            </button>
                        ))}
                    </div>
                </div>

                {/* 포트폴리오 목록 */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                    {filteredItems?.map((item: any) => (
                        <div key={item.id} className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow duration-200">
                            {/* 썸네일 */}
                            <div className="relative">
                                <img
                                    src={item.thumbnail}
                                    alt={item.title}
                                    className="w-full h-48 sm:h-56 lg:h-64 object-cover"
                                />
                                <div className="absolute top-3 right-3 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded">
                                    {formatDuration(item.duration)}
                                </div>
                                <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center">
                                    <div className="w-16 h-16 bg-white bg-opacity-90 rounded-full flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-200">
                                        <svg className="w-8 h-8 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* 내용 */}
                            <div className="p-4 sm:p-6">
                                <div className="mb-3">
                                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                                        item.category === 'vocal' ? 'bg-blue-100 text-blue-800' :
                                        item.category === 'dance' ? 'bg-green-100 text-green-800' :
                                        'bg-purple-100 text-purple-800'
                                    }`}>
                                        {portfolioData?.categories?.find((c: any) => c.id === item.category)?.name}
                                    </span>
                                </div>
                                
                                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 line-clamp-2">
                                    {item.title}
                                </h3>
                                
                                <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                                    {item.description}
                                </p>

                                {/* 태그 */}
                                <div className="mb-4">
                                    <div className="flex flex-wrap gap-1">
                                        {item.tags.slice(0, 3).map((tag: string, index: number) => (
                                            <span key={index} className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
                                                #{tag}
                                            </span>
                                        ))}
                                        {item.tags.length > 3 && (
                                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
                                                +{item.tags.length - 3}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* 통계 */}
                                <div className="flex items-center justify-between text-sm text-gray-500">
                                    <span>{item.date}</span>
                                    <div className="flex items-center gap-3">
                                        <span className="flex items-center gap-1">
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                            {formatViews(item.views)}
                                        </span>
                                        <span className="flex items-center gap-1">
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                            </svg>
                                            {formatViews(item.likes)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* 새 포트폴리오 추가 버튼 */}
                <div className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8">
                    <button className="w-14 h-14 sm:w-16 sm:h-16 bg-[#CF3688] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 flex items-center justify-center">
                        <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                        </svg>
                    </button>
                </div>
            </div>
        </main>
    );
};

export default GrowthPortfolio;
